import { ENV, getEnv } from './env';

export const fullScreenFlag = [ENV.DEV, ENV.UAT].includes((getEnv()));
export const settingsFlag = [ENV.DEV, ENV.UAT].includes((getEnv()));
export const jobVideoPlayerFlag = [ENV.DEV, ENV.UAT].includes((getEnv()));
